export default "__VITE_ASSET__Z1aowqLv__"